import React, { useEffect, useState } from 'react';
import { GoDotFill } from "react-icons/go";
import { FiGlobe } from "react-icons/fi";
import { FaTwitter } from "react-icons/fa6";
import { MdMoreHoriz } from "react-icons/md";
import { getCollectionDetails } from '../../hooks/Collectionhook';
import { ethers } from 'ethers';
import { airDrop_contract_address } from '../../config/BackendUrl';
import logo from "../../assets/img/logos/dtoc-logo.png";
import Papa from 'papaparse';
import { Link, useNavigate } from 'react-router-dom';
import { loadNFTsForaCollection } from '../../assets/Data/NFT';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import airDropAbi from '../../config/ABIs/AirDrop';
import { collectionABI } from '../../config/ABIs/CollectionABI';

const social_media = [
    { icon: <FiGlobe size={23} />, link: "x" },
    { icon: <FaTwitter size={23} />, link: "x" },
    { icon: <MdMoreHoriz size={23} />, link: "x" }
]
const artDescription = `
As the old saying goes, "Be careful what you wish for." But is that always true? 
In "Puppets of Fate," artist Chae Tongyull explores the delicate and sometimes dangerous balance between desire and destiny. 
Reading like an ancient fable, this series of three NFTs weaves a tale of love, loss, and the enchanting power of the heart in shaping our fate.
However, just like love- the moral of this story lies in the eye of the beholder. 
Where is the magic in a life without wishes? Is a life without dreams truly worth living? You decide your fate.

These pieces are based on Chae Tongyull’s breakout series “Medieval Tales” from the 1980s and given new life through Midjourney.

Holders of all three “Puppets of Fate” NFTs will automatically be granted access to the exclusive “Dream House” NFT, the fourth in this set, upon selling out.
`;

const VolumeData = [
    { text: "Total volume", value: "0 ETH" },
    { text: "Floor price", },
    { text: "Best offer", },
    { text: "Listed", value: "0 ETH" },
    { text: "Owners (Unique)", value: "0 ETH" },
]
const Chain_Value = [
    { key: "Item", value: 12 },
    { key: "Created", value: "May 2024" },
    { key: "Creator earnings", value: "10%" },
    { key: "Chain", value: "Ethereum" },
]

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',

        transform: 'translate(-50%, -50%)',
    },
};
const BannerForDrop = (props) => {
    const [show, setShow] = useState(false);
    const [collectionDetails, setCollectionDetails] = useState(null);
    const [collection, setCollection] = useState([]);
    const collectionAddress = props.collectionAddress;
    const [modalIsOpen, setIsOpen] = useState(false);
    const [modalIsOpen1, setIsOpen1] = useState(false);
    const [modalIsOpen2, setIsOpen2] = useState(false);
    const [check, setCheck] = useState(false);
    const [userWalletAddress, setUserWalletAddress] = useState([]);
    const route = useNavigate();
    const PROVIDER = useSelector((state) => state.valueFromHeader);

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    function openModal1() {
        setIsOpen1(true);
    }

    function closeModal1() {
        setIsOpen1(false);
    }
    function openModal2() {
        setIsOpen(true);
    }

    function closeModal2() {
        setIsOpen2(false);
    }
    // const handleSelectChange = (selected, check) => {
    //     console.log("selec", selected, check, collection);

    //     const Filters = collection.map((value) => {
    //         if (value.label === selected) {
    //             return { ...value, check: !check }
    //         }
    //         else {
    //             return value
    //         }
    //     })
    //     setCollection(Filters)

    // };

    // const handleSelectAll = () => {
    //     const Filters = collection.map((value) => {
    //         return { ...value, check: !check }
    //     })
    //     setCheck(!check);
    //     setCollection(Filters);
    // };


    const handleSelectChange = (selectedLabel, isChecked) => {
        setCollection(prevCollection =>
            prevCollection.map(item =>
                item.label === selectedLabel ? { ...item, check: !isChecked } : item
            )
        );
    };

    const handleSelectAll = () => {
        setCollection(prevCollection =>
            prevCollection.map(item => ({ ...item, check: !prevCollection.every(i => i.check) }))
        );
    };
    useEffect(() => {
        getCollectionDetails(collectionAddress).then((data) => {
            if (data.status === 201) {
                Chain_Value[1].value = data.data.createdAt.split('T')[0];
            }
            setCollectionDetails(data.data)
            GetCollectionDetails(data.data.ownerAddress);

        })
    }, [collectionAddress]);

    const GetCollectionDetails = async (owner) => {
        const updatedNFTs = await loadNFTsForaCollection(collectionAddress);
        if (updatedNFTs.length !== 0) {
            const UpdateNFTData = updatedNFTs.map((value) => {
                if (value.owner === owner) {
                    return value
                }
                else {
                    return null
                }
            })
            const AvailableNFTArr = UpdateNFTData.filter((data => data !== null));
            setCollection(AvailableNFTArr)
            await callMyFunction(owner);
        }
    }

    const onChange = (event) => {
        const uploadedFile = event.target.files[0];
        if (uploadedFile) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const csvData = event.target.result;
                // Parse the CSV data using papaparse
                const parsedData = Papa.parse(csvData, { header: true }); // Adjust options as needed
                const Arr = []
                parsedData.data.map((value) => {
                    Object.entries(value).map(([key, value]) => {
                        if (value !== "") {
                            Arr.push(value);
                        }
                    })
                })
                setUserWalletAddress(Arr);
            };
            reader.readAsText(uploadedFile);
        } else {
            toast.error("Please select a CSV file");
        }
    };

    const [walletAdd, setWalletAdd] = useState(null);

    const addWalletOnChange = (value) => {
        setWalletAdd(value);
    }
    const AddWalletAddress = () => {
        const GetCheck = collection.filter(data => data.check === true);
        if (GetCheck.length !== 0) {
            if (GetCheck.length > userWalletAddress.length) {
                if (walletAdd) {
                    setUserWalletAddress([...userWalletAddress, walletAdd]);
                }
            }
            else {
                toast.error("We only Add Wallet Address equal to Selected NFTs")
            }
        }
        else {
            toast.error("Please select NFTs First !!!");
        }
    };

    const ApporvalIsTrue = async () => {
        closeModal2()
        openModal()
    };

    const callMyFunction = async (owner) => {
        try {
            const wallet = await PROVIDER.getSigner();
            const contracts = new ethers.Contract(
                collectionAddress,
                collectionABI,
                wallet
            );

            const test = await contracts.isApprovedForAll(
                owner,
                airDrop_contract_address
            );
            if (test === false) {
                openModal1()
            }
            else {
                openModal2()
            }
        } catch (error) {
            toast.error("Error calling function:", error);
        }
    };

    const ApporvalIsFalse = async () => {
        closeModal1()
        try {
            // const provider = new BrowserProvider(window.ethereum);

            const wallet = await PROVIDER.getSigner();

            const contracts = new ethers.Contract(
                collectionAddress,
                collectionABI,
                wallet
            );

            const test = await contracts.setApprovalForAll(
                airDrop_contract_address,
                true
            );
            const receipt = await test.wait();
            if (receipt) {
                toast.success("Transaction successful:");
                openModal()
            }
        } catch (error) {
            toast.error("Error calling function:", error);
        }
    };
    console.log("userWalletAddress", userWalletAddress);

    const DropNFTCollection = async () => {
        try {
            // const provider = new BrowserProvider(window.ethereum);

            const wallet = await PROVIDER.getSigner();

            const NFTTokenIds = [];
            collection.filter(value => value.check === true).map((data) => {
                const Id = (data.tokenId)
                NFTTokenIds.push(Id)
            })

            const contracts = new ethers.Contract(
                airDrop_contract_address,
                airDropAbi,
                wallet
            );

            const test = await contracts.bulkAirdrop(
                collectionAddress,
                userWalletAddress,
                NFTTokenIds
            );
            const receipt = await test.wait();
            if (receipt) {
                toast.success("Transaction successful:");
                setTimeout(() => {
                    route('/collections');
                }, 2000);
            }
        } catch (error) {
            toast.error("Error calling function:", error);
        }
    };

    return (
        <>
            <div className='banner'>
                <div className='banner_part'>
                    <video
                        autoPlay muted loop
                        playsInline
                    >
                        <source src="https://stream.mux.com/gWNXuJ01EMYV01HvRh1I3dXu02zYH3qDqTMuzaU7r2XtTA/high.mp4" type="video/mp4" />
                    </video>
                </div>
                <div className="row collection_Details">
                    <div className="banner_collection col-lg-6 col-sm-12">
                        <div className="banner_collection_Data">
                            <div className="logo space-y-20">
                                {collectionDetails === null ?
                                    <img src="https://i.seadn.io/s/raw/files/04806b9bfa9bddb6e0fd147285675639.gif?auto=format&amp;dpr=1&amp;w=3840" alt="" /> :
                                    <img src={`${collectionDetails.logo}`} alt="" />}
                            </div>
                            <div className="mining_button">
                                <div className="gif">
                                    <GoDotFill color="#68f2ab" />
                                </div>
                                <div className="text">
                                    Minitng
                                </div>
                            </div>

                            <div className='collection_name_social d-flex align-items-center justify-content-start'>
                                <div className="coll_name">
                                    <h3 className='color_white'>
                                        {collectionDetails !== null ? collectionDetails.name : "Collection Name"}
                                    </h3>
                                </div>
                                <div className='hr'></div>
                                <div className="collection_social">
                                    {social_media.map((social) => (
                                        <div className='social_icon'>
                                            <a href="http://" target="_blank" rel="noopener noreferrer">
                                                {social.icon}
                                            </a>
                                        </div>
                                    ))}

                                </div>
                            </div>
                            {show ?
                                <>
                                    <pre className={`${show ? "collection_pre_desc" : "collection_pre_desc_0"}`} style={{ whiteSpace: 'pre-line' }}>
                                        {artDescription}
                                    </pre>
                                    <span className='pre_show' onClick={() => setShow(false)}>Show Less</span>
                                </>
                                :
                                <>
                                    <pre className={`${show ? "collection_pre_desc" : "collection_pre_desc_0"}`} style={{ whiteSpace: 'pre-line' }}>
                                        {artDescription.trim().substring(0, 65)}...
                                        <span className='pre_show' onClick={() => setShow(true)}>Show More</span>
                                    </pre>
                                </>
                            }
                            <div className="collection_chain_value ">
                                {Chain_Value.map((data) => (
                                    <div className='m-10'>
                                        <div className='text-center chain_value' style={{ whiteSpace: "nowrap" }}>
                                            <span className='chain_value_key'>
                                                {data.key}
                                            </span><span className='chain_value_value'>
                                                {data.value ? data.value : "--"}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="collection_value col-lg-6 col-sm-12">

                        <div className="collection_volume ">
                            {VolumeData.map((data) => (
                                <div className='m-10'>
                                    <div className='text-center volume_value' style={{ whiteSpace: "nowrap" }}>{data.value ? data.value : "--"}</div>
                                    <div style={{ whiteSpace: "nowrap" }}>{data.text}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={modalIsOpen1}
                onHide={closeModal1}
                ariaHideApp={false}
                size="lg"
                contentLabel="Example Modal"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <img src={logo} style={{ width: "8rem" }} alt="" />
                    </Modal.Title>

                </Modal.Header>
                <Modal.Body>
                    <div className='m-4'>
                        <h4>
                            Are you want to Update Approval State ?
                        </h4>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-sm btn-primary" onClick={closeModal1}>No </button>
                    <button className="btn btn-sm btn-primary" onClick={ApporvalIsFalse}>Yes</button>

                </Modal.Footer>
            </Modal>

            <Modal
                show={modalIsOpen2}
                onRequestClose={closeModal2}
                ariaHideApp={false}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <img src={logo} style={{ width: "8rem" }} alt="" />
                    </Modal.Title>

                </Modal.Header>
                <Modal.Body>
                    <div className='m-4'>
                        <h4>
                            You have to Drop {collectionDetails !== null ? collectionDetails.name : "Collection Name"} collection  ?
                        </h4>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-sm btn-primary" onClick={closeModal2}>No </button>
                    <button className="btn btn-sm btn-primary" onClick={ApporvalIsTrue}>Yes</button>
                </Modal.Footer>
            </Modal>


            <Modal
                show={modalIsOpen}
                onRequestClose={closeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <img src={logo} style={{ width: "8rem" }} alt="" />
                    </Modal.Title>

                </Modal.Header>

                <Modal.Body>
                    <div className='row'>
                        <div className='col-sm-12 col-lg-6'>
                            <h4>
                                Select NFT for airDrop ?
                            </h4>
                            <h6 className='my-4'>
                                {collection.filter(data => data.check === true).length} Selected NFTs
                            </h6>
                            <div>
                                <div className="interest-container  creator-scroll-container-card row">
                                    {collection.map((res, index) => (
                                        <div className="my-3 col-sm-6 col-md-6 col-lg-4" key={index}>

                                            <div className="interest-master-card"
                                                onClick={() => handleSelectChange(res.label, res.check)}
                                            >

                                                <img className={
                                                    res.check
                                                        ? "iterest-card-active  " : "iterest-card"

                                                } src={res.image} alt="" />
                                            </div>
                                            <div className='tokenId my-2'>

                                                <span className={
                                                    res.check
                                                        ? "iterest-card-active " : "iterest-card"

                                                }>token Id : {res.tokenId !== undefined ? res.tokenId : null}</span>
                                            </div>


                                        </div>
                                    ))}
                                </div>
                                <button className='btn btn-sm btn-primary my-3' onClick={handleSelectAll}>Select All</button>
                            </div>
                            {/* <div>
                                <div class="interest-container creator-scroll-container-card row">
                                    <ul class="interest-list">
                                        {collection.map((res, index) => (
                                            <li
                                                key={index}
                                                class="interest-card my-3 col-sm-6 col-md-6 col-lg-4"
                                                onClick={() => handleSelectChange(res.label, res.check)}
                                            >
                                                <img
                                                    class={`interest-card-img ${res.check ? 'iterest-card-active' : ''}`}
                                                    src={res.image}
                                                    alt=""
                                                />
                                                <div className="tokenId my-2">
                                                    <span className={`iterest-card-text ${res.check ? 'iterest-card-active' : ''}`}>
                                                        token Id: {res.tokenId !== undefined ? res.tokenId : null}
                                                    </span>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <button class="btn btn-sm btn-primary my-3" onClick={handleSelectAll}>
                                    Select All
                                </button>
                            </div> */}
                        </div>
                        <div className="left__part space-y-40 md:mb-20 col-sm-12 col-lg-6">
                            <div className='d-flex align-items-center justify-content-between'>
                                <h6 className='my-4'>
                                    {userWalletAddress.length} Upload Users
                                </h6>
                                <div className=' upload_file'>


                                    <Link className="btn btn-grad btn-grad">
                                        Upload CSV File{" "}
                                    </Link>
                                    <input type="file" accept=".csv" onChange={onChange} />
                                </div>
                            </div>
                            <div className="space-y-20">

                                {userWalletAddress.length ?
                                    userWalletAddress.slice(0, 4).map((data) =>
                                        <div>
                                            {data && "Address:"} {data}
                                        </div>
                                    ) : null
                                }
                                {userWalletAddress.length > 5 &&
                                    <>
                                        {userWalletAddress.length ?
                                            <div className="space-y-20">
                                                <h5>- <br /> - <br /> - <br /> - <br />                   </h5>
                                            </div>
                                            : null
                                        }

                                        {userWalletAddress.length ?
                                            userWalletAddress.slice(-4).map((data) =>
                                                <div>
                                                    {data && "Address:"} {data}
                                                </div>
                                            ) : null
                                        }
                                    </>}
                                <h5 className="color_text p3">or Add User Wallet Address </h5>
                                <div className='d-flex align-items-center '>
                                    <input type="text" placeholder="User Wallet Address" name='WalletAddress' id="" onChange={(e) => addWalletOnChange(e.target.value)} />
                                    <button className='btn btn-sm btn-primary ml-4' onClick={AddWalletAddress}> Add</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {/* <div className='d-flex align-items-center justify-content-between'> */}
                    <button className="btn btn-sm btn-primary" onClick={closeModal}>No </button>
                    <button className="btn btn-sm btn-primary" disabled={collection.length === 0 ? true : false} onClick={DropNFTCollection}>Yes</button>
                    {/* </div> */}
                </Modal.Footer>
            </Modal>
            <ToastContainer position="bottom-right" />
        </>
    );
};

export default BannerForDrop;
